export default {
  baseUrl: 'https://tracker-dev.rocket-lab.ru',
  publicPath: 'https://tracker2.rocket-lab.ru/static',
  fieldUrl: 'https://tracker-dev.rocket-lab.ru/field',
  title: 'Трекер посылок 2'
}